<template>
  <section class="blog">
    <b-container>
      <div class="lg-none">
        <ProductsNav :id="id"></ProductsNav>
      </div>
    </b-container>
    <router-view></router-view>
  </section>
</template>

<script>
import ProductsNav from "../components/blog-nav";
export default {
  data() {
    return {
      id: `1`
    };
  },
  components: {
    ProductsNav
  }
};
</script>



